"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var CONSTRAINT_TYPE = {
    defaultDouble: 'default_double',
    double: 'double',
    text: 'text',
    row: 'row',
    col: 'col'
};
var DATA_VALID = true;
var DATA_INVALID = false;
function formatCell(val, decimalPoint) {
    if (typeof val === 'undefined' || val === null) {
        return '""';
    }
    var str = val.toString().trim();
    if (!isNaN(val)) {
        return str.replace('.', decimalPoint);
    }
    return "\"" + str + "\"";
}
function getPastedStuffFromEvent($event) {
    var pastedStuff;
    if ($event.originalEvent &&
        $event.originalEvent.clipboardData &&
        $event.originalEvent.clipboardData.getData) {
        pastedStuff = $event.originalEvent.clipboardData.getData('text/plain');
    }
    else if (window.clipboardData) { // IE
        pastedStuff = window.clipboardData.getData("Text");
    }
    var t = pastedStuff.trim();
    if (t.indexOf('\n') < 0 && t.indexOf('\r') < 0) {
        return null;
    }
    return pastedStuff;
}
function getReferenceData(mainReference, siblingReference, decimals) {
    if (!mainReference) {
        return null;
    }
    return Object.entries(mainReference).map(function (_a) {
        var key = _a[0], value = _a[1];
        var headerText = value.Display + (value.Units ? (' (' + value.Units + ')') : '');
        var val = typeof value.Val === 'number' ? value.Val.toFixed(decimals) : value.Val;
        var shadow = null;
        if (key in siblingReference) {
            shadow = typeof siblingReference[key].Val === 'number' ?
                siblingReference[key].Val.toFixed(decimals) :
                siblingReference[key].Val;
        }
        return { headerText: headerText, val: val, shadow: shadow };
    });
}
exports.getReferenceData = getReferenceData;
var TableInput = /** @class */ (function () {
    /**
     * Assume the template in table and sibling table is always the same.
     * That means the col headers and row headers are always the same.
     * Throw error if templates are different.
     *
     * @param node
     * @param tableDef
     * @param siblingNode
     * @param siblingTableDef
     */
    function TableInput(node, tableDef, siblingNode, siblingTableDef) {
        var Constraint = tableDef.Constraint, DefaultConstraint = tableDef.DefaultConstraint, Val = tableDef.Val, Inherited = tableDef.Inherited, RowConstraint = tableDef.RowConstraint, ColConstraint = tableDef.ColConstraint;
        this.constraint = {
            "default": DefaultConstraint || Constraint,
            row: RowConstraint || {},
            col: ColConstraint || {}
        };
        this.originData = Val.Data;
        this.isInherited = Inherited || false;
        this.hasSibling = siblingTableDef || false;
        this.siblingData = this.hasSibling ? siblingTableDef.Val : null;
        this.siblingNode = siblingNode;
        this.colHeaders = this.generateTableColHeaders(Val.ColHeaders, this.hasSibling);
        this.data = this.generateTableData(node, Val, siblingNode, this.siblingData);
    }
    TableInput.prototype.setNewData = function (node, tableDef) {
        var Constraint = tableDef.Constraint, DefaultConstraint = tableDef.DefaultConstraint, Val = tableDef.Val, Inherited = tableDef.Inherited, RowConstraint = tableDef.RowConstraint, ColConstraint = tableDef.ColConstraint;
        this.colHeaders = this.generateTableColHeaders(Val.ColHeaders, this.hasSibling);
        this.data = this.generateTableData(node, Val, this.siblingNode, this.siblingData);
    };
    TableInput.prototype.generateTableColHeaders = function (colHeaders, hasSibling) {
        var isHeaderColumn = true;
        var initHeaders = hasSibling ? [
            { displayName: 'Path', field: 'nodePath', isHeaderColumn: isHeaderColumn, exportOnly: true },
            { displayName: 'Project Nodes', field: 'nodeName', isHeaderColumn: isHeaderColumn },
            { displayName: '', field: 'rowHeader', isHeaderColumn: isHeaderColumn }
        ] : [
            { displayName: '', field: 'rowHeader', isHeaderColumn: isHeaderColumn }
        ];
        var valueHeaders = colHeaders.map(function (h, index) { return ({
            displayName: isNaN(h) ? h.toString().trim() : h,
            field: index.toString()
        }); });
        return initHeaders.concat(valueHeaders);
    };
    TableInput.prototype.generateTableData = function (node, tableDefVal, siblingNode, siblingTableDefVal) {
        var mainRows = this.generateRows(node, tableDefVal);
        if (siblingTableDefVal) {
            var siblingRows = this.generateRows(siblingNode, siblingTableDefVal, true);
            var result = [];
            var rowsCount = mainRows.length;
            for (var i = 0; i < rowsCount; i++) {
                result.push(mainRows[i]);
                result.push(siblingRows[i]);
            }
            result.forEach(function (row, index) { return row.index = index; });
            return result;
        }
        return mainRows;
    };
    TableInput.prototype.generateRows = function (node, tableDefVal, isSibling) {
        if (isSibling === void 0) { isSibling = false; }
        if (!tableDefVal) {
            return null;
        }
        var rowHeaders = tableDefVal.RowHeaders;
        var Data = tableDefVal.Data, Type = tableDefVal.Type;
        var nodeName = node.name;
        // When get breadcrumb function is not available, use node name. (For common data)
        var nodePath = node.getBreadcrumb ? node.getBreadcrumb() : node.name;
        return Data.map(function (row, index) {
            var r = {
                index: index,
                nodeName: nodeName,
                nodePath: nodePath,
                isSibling: isSibling,
                color: isSibling ? 'darkorange' : 'black',
                rowHeader: rowHeaders[index].trim()
            };
            row.forEach(function (cell, index) {
                r[index.toString()] = {
                    type: Type,
                    value: cell,
                    originValue: cell
                };
            });
            return r;
        });
    };
    TableInput.prototype.generateDataForSaving = function () {
        var dataHeaders = this.colHeaders.filter(function (col) { return !col.isHeaderColumn; });
        var mainRows = this.data.filter(function (row) { return !row.isSibling; });
        return mainRows.map(function (row) { return dataHeaders.map(function (col) { return row[col.field].value; }); });
    };
    /**
     * Check whether cell value is valid.
     *
     * @param cell {any} cell object.
     * @param row {string} row header display name.
     * @param col {string} col header display name.
     */
    TableInput.prototype.checkCellValue = function (cell, row, col) {
        var cellConstraint = this.constraint.row[row] || this.constraint.col[col] || this.constraint["default"];
        if (cellConstraint === CONSTRAINT_TYPE.double || cellConstraint === CONSTRAINT_TYPE.defaultDouble) {
            var val = Number(cell.value);
            if (isNaN(val)) {
                cell.backgroundColor = '#E8B3AE';
                return DATA_INVALID;
            }
            else {
                cell.value = val;
                cell.backgroundColor = (val === cell.originValue ? null : '#BBE7FF');
                return DATA_VALID;
            }
        }
        else {
            cell.backgroundColor = (cell.value === cell.originValue ? null : '#BBE7FF');
            return DATA_VALID;
        }
    };
    TableInput.prototype.checkDirty = function () {
        var _this = this;
        var state = DATA_VALID;
        this.isDirty = this.data.filter(function (row) {
            return _this.colHeaders.filter(function (col) {
                if (!col.isHeaderColumn) {
                    var cell = row[col.field];
                    if (_this.checkCellValue(cell, row.rowHeader, col.displayName) === DATA_INVALID) {
                        state = DATA_INVALID;
                    }
                    return cell.value !== cell.originValue;
                }
            }).length > 0;
        }).length > 0;
        this.isValid = state === DATA_VALID;
    };
    TableInput.prototype.reset = function () {
        var _this = this;
        this.data.forEach(function (row) {
            _this.colHeaders.forEach(function (col) {
                if (!col.isHeaderColumn) {
                    var cell = row[col.field];
                    cell.value = cell.originValue;
                    cell.backgroundColor = null;
                }
            });
        });
        this.isDirty = false;
        this.isValid = true;
    };
    TableInput.prototype.saveToOrigin = function (newData) {
        this.originData = newData;
    };
    TableInput.prototype.getGridOptions = function (isReadOnly, uiGridEditConstants, alertFunction) {
        var _this = this;
        if (uiGridEditConstants === void 0) { uiGridEditConstants = undefined; }
        if (alertFunction === void 0) { alertFunction = null; }
        this.showAlert = alertFunction || (function (msg) { return alert(msg); });
        var pasteInCell = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.pasteAtCell.apply(_this, args);
        };
        if (!this.uiGridEditConstants) {
            this.uiGridEditConstants = uiGridEditConstants;
        }
        var editable = !(this.isInherited || isReadOnly);
        var gridHeaders = this.colHeaders.filter(function (col) { return !col.exportOnly; });
        var colDefs = gridHeaders.map(function (header, headerIndex) {
            return {
                index: headerIndex,
                enableSorting: false,
                enableHiding: false,
                name: header.displayName,
                displayName: header.displayName,
                field: header.field,
                width: header.isHeaderColumn ? 200 : 100,
                pinnedLeft: header.isHeaderColumn,
                cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {
                    if (header.isHeaderColumn) {
                        return 'grid-row-header';
                    }
                    return (!row.entity.isSibling && editable) ? 'form-control' : null;
                },
                cellEditableCondition: function (scope) {
                    return !scope.row.entity.isSibling;
                },
                enableCellEdit: editable ? (!header.isHeaderColumn) : false,
                cellTemplate: header.isHeaderColumn ? '<div>' +
                    '<div class="ui-grid-cell-contents">' +
                    '<b>{{COL_FIELD.value || COL_FIELD CUSTOM_FILTERS}}</b>' +
                    '</div>' : '<div class="ui-grid-cell-contents" ' +
                    '  ng-style="{\'background-color\': COL_FIELD.backgroundColor}">' +
                    '  {{COL_FIELD.value}}' +
                    '</div>',
                editableCellTemplate: '<div><form name="inputForm">\n' +
                    '<input type="INPUT_TYPE"\n' +
                    '  ng-class="\'colt\' + col.uid"\n' +
                    '  ui-grid-editor\n' +
                    '  style="padding: 4px;"' +
                    '  ng-paste="row.entity.pasteInCell($event, row.entity, col.colDef, this)"' +
                    '  ng-model="MODEL_COL_FIELD.value" />\n' +
                    '</form></div>'
            };
        });
        var ctrl = this;
        return {
            columnDefs: colDefs,
            rowTemplate: '<div style="text-overflow: ellipsis" ng-style="{\'color\': row.entity.color }">' +
                '    <div style="text-overflow: ellipsis" ng-if="!row.entity.merge" ' +
                '       ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
                '       class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell>' +
                '  </div>' +
                '</div>',
            enableCellEditOnFocus: true,
            data: this.data.map(function (d) { return (__assign({}, d, { pasteInCell: pasteInCell })); }),
            onRegisterApi: function (gridApi) {
                ctrl.removeEditHandler = gridApi.edit.on.afterCellEdit(null, function (rowEntity, colDef, newValue, oldValue) {
                    ctrl.checkDirty();
                });
            }
        };
    };
    TableInput.prototype.verifyColHeaders = function (colHeaders) {
        if (colHeaders.length !== this.colHeaders.length) {
            throw Error('Column header count mismatched!');
        }
        for (var i = 0; i < colHeaders.length; i++) {
            if (colHeaders[i].toString().trim() !== this.colHeaders[i].displayName.toString().trim()) {
                throw Error("Column header mismatched. Check column " + (i + 1) + " (" + colHeaders[i] + ")!");
            }
        }
    };
    TableInput.prototype.verifyRowHeaders = function (rows) {
        if (rows.length !== this.data.length) {
            throw Error('Row header count mismatched!');
        }
        var headerColCount = this.hasSibling ? 3 : 1;
        for (var i = 0; i < rows.length; i++) {
            for (var j = 0; j < headerColCount; j++) {
                if (rows[i][j].toString().trim() !== this.data[i][this.colHeaders[j].field].toString().trim()) {
                    throw Error("Row header mismatched. Check row " + (i + 1) + " (" + rows[i][j] + ")!");
                }
            }
        }
    };
    TableInput.prototype.processPasteEvent = function ($event) {
        var inputStr = getPastedStuffFromEvent($event);
        if (!inputStr) {
            return null;
        }
        var lineSeparator = inputStr.indexOf('\n') >= 0 ? '\n' : '\r';
        var excelRows = inputStr.split(lineSeparator);
        var newData = excelRows.filter(function (row) {
            return row && row.trim();
        }).map(function (row) {
            return row.replace('\r', '').split('\t');
        });
        if (newData.length === 0) {
            return null;
        }
        return newData;
    };
    TableInput.prototype.pasteAtCell = function ($event, row, col, childScope) {
        var inputData = this.processPasteEvent($event);
        if (!inputData) {
            return;
        }
        if (inputData.length === this.data.length + 1 && inputData[0].length === this.colHeaders.length) {
            try {
                this.pasteFullTable(inputData);
            }
            catch (err) {
                this.showAlert('danger', 'Error Pasting!', err);
            }
        }
        else {
            this.pastePartial(inputData, row, col);
        }
        childScope.$emit(this.uiGridEditConstants.events.END_CELL_EDIT);
        this.checkDirty();
    };
    TableInput.prototype.pastePartial = function (inputData, row, col) {
        var startRowIndex = row.index;
        var startColIndex = col.index;
        var tableData = this.data;
        var tableColHeaders = this.colHeaders.filter(function (col) { return !col.exportOnly; });
        var dataRowsCount = inputData.length;
        for (var i = 0; i < dataRowsCount; i++) {
            var inputDataRow = inputData[i];
            if (i + startRowIndex >= tableData.length) {
                continue;
            }
            var tableRow = tableData[i + startRowIndex];
            if (tableRow.isSibling) {
                continue;
            }
            for (var j = 0; j < inputDataRow.length; j++) {
                if (j + startColIndex >= tableColHeaders.length) {
                    continue;
                }
                var fieldKey = tableColHeaders[j + startColIndex].field;
                tableRow[fieldKey].value = inputDataRow[j];
            }
        }
    };
    TableInput.prototype.pasteFullTable = function (inputData) {
        var _this = this;
        var headerRow = inputData.splice(0, 1)[0];
        this.verifyColHeaders(headerRow);
        this.verifyRowHeaders(inputData);
        this.data.forEach(function (row, rowIndex) {
            if (!row.isSibling) {
                var newDataRow_1 = inputData[rowIndex];
                _this.colHeaders.forEach(function (col, colIndex) {
                    if (!col.isHeaderColumn) {
                        row[col.field].value = newDataRow_1[colIndex];
                    }
                });
            }
        });
    };
    TableInput.prototype.convertArrtoObjHeaders = function (headersArray, rows) {
        var colHeadersMod = [];
        headersArray.map(function (k, i) {
            colHeadersMod.push({ displayName: k, field: i });
        });
        return { colHeadersMod: colHeadersMod, rows: rows };
    };
    TableInput.prototype.toCSVCustom = function (csvFormat, data, colHeaders) {
        // const colHeaders = this.colHeaders;
        // const rows = data[0];
        if (csvFormat === void 0) { csvFormat = 'US'; }
        var cellSeparator = csvFormat === 'EU' ? ';' : ',';
        var decimalPoint = csvFormat === 'EU' ? ',' : '.';
        var _a = this.convertArrtoObjHeaders(colHeaders, data), colHeadersMod = _a.colHeadersMod, rows = _a.rows;
        var lines = [];
        lines.push(colHeadersMod.map(function (header) { return formatCell(header.displayName, decimalPoint); }).join(cellSeparator));
        rows.forEach(function (row) {
            lines.push(colHeadersMod.map(function (x) {
                if (x.isHeaderColumn) {
                    return formatCell(row[x.field], decimalPoint);
                }
                else {
                    return formatCell(row[x.field], decimalPoint);
                }
            }).join(cellSeparator));
        });
        return lines.join('\n');
    };
    TableInput.prototype.toCSVMerge = function (csvFormat, data) {
        if (csvFormat === void 0) { csvFormat = 'US'; }
        var colHeaders = this.colHeaders;
        var rows = data;
        var cellSeparator = csvFormat === 'EU' ? ';' : ',';
        var decimalPoint = csvFormat === 'EU' ? ',' : '.';
        var colHeadersMod = colHeaders;
        var lines = [];
        lines.push(colHeadersMod.map(function (header) { return formatCell(header.displayName, decimalPoint); }).join(cellSeparator));
        rows.forEach(function (row) {
            lines.push(colHeadersMod.map(function (x) {
                if (x.isHeaderColumn) {
                    return formatCell(row[x.field], decimalPoint);
                }
                else {
                    return formatCell(row[x.field].value, decimalPoint);
                }
            }).join(cellSeparator));
        });
        return lines.join('\n');
    };
    TableInput.prototype.toCSV = function (csvFormat) {
        if (csvFormat === void 0) { csvFormat = 'US'; }
        var colHeaders = this.colHeaders;
        var rows = this.data;
        var cellSeparator = csvFormat === 'EU' ? ';' : ',';
        var decimalPoint = csvFormat === 'EU' ? ',' : '.';
        var colHeadersMod = colHeaders;
        var lines = [];
        lines.push(colHeadersMod.map(function (header) { return formatCell(header.displayName, decimalPoint); }).join(cellSeparator));
        rows.forEach(function (row) {
            lines.push(colHeadersMod.map(function (x) {
                if (x.isHeaderColumn) {
                    return formatCell(row[x.field], decimalPoint);
                }
                else {
                    return formatCell(row[x.field].value, decimalPoint);
                }
            }).join(cellSeparator));
        });
        return lines.join('\n');
    };
    TableInput.prototype.onDestroy = function () {
        if (this.removeEditHandler) {
            this.removeEditHandler();
        }
    };
    return TableInput;
}());
exports["default"] = TableInput;
//# sourceMappingURL=table-input.logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/table-input2/table-input.logic.js